/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./PxPercentUtil',
	'@waca/dashboard-common/js/utils/CommonUtil'
], function(PxPercentUtil, CommonUtil) {

	const COMPARE_THRESHOLD = 9; // Mirrored the value from absolute layout grid size 

	class ContentUtils {
		/**
		* Basic sort of contents based on coordinates (x & y)
		* The coordinates will be compared in pixel units
		* @param {ContentAPI[]} contents Array of contents to sort
		* @param {Object} pageSize The page size that contains the contents, used to convert from % to px
		* @param {Object} [comparator] A comparator function to sort the x,y coordinate array of objects.
		* If not provided, a default threshold comparator is used (10px threshold)
		* @returns {ContentAPI[]} New array of sorted contents
 		* @throws Will throw an error if any of the arguments are invalid.
		*/
		static getSortedContentsByPosition(contents, pageSize, comparator) {
			if (!contents || !Array.isArray(contents) || !pageSize) {
				throw new Error('Invalid options specified.');
			}
			const sortComparator = comparator || CommonUtil.positionComparator(COMPARE_THRESHOLD);
			return contents.map(function(content) {
				const contentPosition = {
					top: content.getPropertyValue('top'),
					left: content.getPropertyValue('left')
				};
				PxPercentUtil.changePercentPropertiesToPixel(contentPosition, pageSize);
				return { x: parseInt(contentPosition.left), y: parseInt(contentPosition.top), content };
			})
				.sort(sortComparator)
				.map((o) => (o.content));
		}
	}
	return ContentUtils;
});
